module.exports = __webpack_public_path__ + "static/media/html.1f681c05.webp";